/** @jsx jsx */
import Img from 'gatsby-image'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { Box, Grid, jsx } from 'theme-ui'
import Thumbnail from '~/components/Generic/Thumbnail'

const KitImages = ({ images = [] }) => {
  const [selectedImage, setSelectedImage] = useState(
    images.length > 0 ? images[0] : null
  )

  return (
    <Box sx={{ position: 'relative' }}>
      <Box
        mb={2}
        sx={{
          marginLeft: 'calc(10% + 12px)',
          marginRight: '40px'
        }}
      >
        <Img fluid={selectedImage.fluid} />
      </Box>
      <Grid
        gap={'12px'}
        columns={1}
        sx={{
          width: '10%',
          position: 'absolute',
          top: '0',
          left: '0'
        }}
      >
        {images.map((image, index) => (
          <Thumbnail
            key={index}
            image={image}
            handleClick={setSelectedImage}
            selected={selectedImage.id === image.id}
          />
        ))}
      </Grid>
    </Box>
  )
}

KitImages.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string
    })
  )
}

export default KitImages
